// export const domain = "http://127.0.0.1:8000/api";
// export const url = "http://127.0.0.1:8000";

export const domain = "https://tcdc-service.kisrasprint.com/api";
// export const domain_web = "https://tcdc-service.kisrasprint.com";
// export const domain_event =  "http://127.0.0.1:8000/api";
// export const domain_event_web =  "https://tcdc-event.kisrasprint.com";
// export const domain_article =  "https://article-center.kisrasprint.com/api";
// export const url = "https://tcdc-service.kisrasprint.com";

// export const domain_event =  "https://event.tcdc.or.th/api";
// export const domain_event_web =  "https://event.tcdc.or.th";
// export const domain_article =  "https://article.tcdc.or.th/api";

// PRODUCTION
// export const domain = "https://test.tcdc.or.th/v1/api";
// export const domain_web = "https://test.tcdc.or.th/v1";
export const domain_web = "https://tcdc-service.kisrasprint.com";
export const domain_event =  "https://test.tcdc.or.th/v1/api";
export const domain_article =  "https://test.tcdc.or.th/v1/api";
export const url = "https://test.tcdc.or.th/v1";
